import {adicRestApi, adicRestApiStatUrl} from "@common/services/restapi";

export const getStatInfo = async (className) => {
  const url = adicRestApiStatUrl
    .segment("/info")
    .query(className)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
